import type React from 'react';

import type { MultiLang } from '../../../../config';

interface Props {
    lang: MultiLang;
    keyword: string[];
}

const FreeKeyword: React.FC<Props> = (props) => {
    const { keyword } = props;
    if (keyword.length === 0) {
        return null;
    }
    const label = keyword.join(', ');
    return <span>{label}</span>;
};

export default FreeKeyword;
